import { render, staticRenderFns } from "./CampaignPerformance.vue?vue&type=template&id=774d83e2&scoped=true"
import script from "./CampaignPerformance.vue?vue&type=script&lang=js"
export * from "./CampaignPerformance.vue?vue&type=script&lang=js"
import style0 from "./CampaignPerformance.vue?vue&type=style&index=0&id=774d83e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d83e2",
  null
  
)

export default component.exports